export const isOilStickerImprovedstyles = `
@import '../assets/fontawesome/css/all.min.css';
      @charset "UTF-8";:root {
        --secondary-400: #889191;
        --secondary-200: #bdc2c2;
        --black: #252828;
        --white: #ffffff;
    }

    .theme-gray-scale {
        --secondary-400: #252828;
        --secondary-200: #bdc2c2;
        --black: #252828;
        --white: #ffffff;
    }
      body {
        font-family: 'Open Sans', sans-serif;
        margin: 0;
      }
    .oil-stamp .single-stamp {
      background: var(--white);
      border-radius: 4px;
      border: 0 solid var(--black);
      color: var(--black);
      overflow: hidden;
    }
    .oil-stamp .single-stamp h4 {
      font-size: 14px;
      font-weight: 600;
      margin: 0;
    }
    .oil-stamp .single-stamp h4 small {
      font-size: 10px;
    }
    .oil-stamp .single-stamp p {
      font-size: 12px;
      margin: 0;
    }
    .oil-stamp .single-stamp .stamp-header {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 3px 0;
      padding-right: 10px;
    }
    .oil-stamp .single-stamp .stamp-header .stamp-logo {
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .oil-stamp .single-stamp .stamp-header .stamp-logo img {
      max-width: 100%;
      max-height: 100%;
    }
    .oil-stamp .single-stamp .stamp-body p {
      font-size: 14px;
      transform: scale(0.857);
      line-height: 1;
    }
    .oil-stamp .single-stamp.custom-header .stamp-header {
      background: var(--secondary-400);
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 !important;
    }
    .oil-stamp .single-stamp.custom-header .stamp-header img {
      max-width: 100%;
      max-height: 100%;
      background: var(--white);
    }
    .oil-stamp .single-stamp .stamp-body {
      background: var(--secondary-200) !important;
      text-align: center;
      padding: 5px;
      font-weight: 600;
      print-color-adjust: exact;
    }
    .oil-stamp .single-stamp .stamp-footer {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      padding: 5px;
    }
    .oil-stamp .single-stamp .stamp-footer .stamp-detail {
      flex: 0 0 50%;
      max-width: calc(50% - 0.5px);
      padding-right: 5px;
    }
    .oil-stamp .single-stamp .stamp-footer .stamp-detail h4 {
      // padding: 2px 5px;
      white-space: nowrap;
    }
    .oil-stamp .single-stamp .stamp-footer .stamp-detail h4 i {
      margin-right: 3px;
    }
    .oil-stamp .single-stamp .stamp-footer .stamp-detail + .stamp-detail {
      border-left: 1px solid var(--secondary-200);
      padding-left: 5px;
      padding-right: 0;
      padding-bottom: 0 !important;
    }
    .oil-stamp .single-stamp .stamp-footer .stamp-car-detail {
      max-width: 100%;
      flex: 0 0 100%;
      padding-top: 6px;
      display: none;
    }
    .oil-stamp .single-stamp .stamp-footer .stamp-car-detail p {
      margin: 0;
      transform: scale(1);
    }
    .oil-stamp .single-stamp .stamp-footer .stamp-car-detail p i {
      margin-right: 3px;
    }

    .oil-stamp .single-stamp.stamp-one {
      width: calc(192px - 2px);
      margin: 1px;
      height: calc(96px - 2px);
    }

    .oil-stamp .single-stamp.stamp-one .stamp-brand {
      flex: 0 0 calc(100% - 40px);
    }
    .oil-stamp .single-stamp.stamp-one h4 {
      font-size: 12px;
    }
    .oil-stamp .single-stamp.stamp-one .stamp-logo {
      width: 40px;
      height: 25px;
    }
    .oil-stamp .single-stamp.stamp-two {
      width: calc(216px - 2px);
      margin: 1px;
      height: calc(120px - 2px);
    }
    .oil-stamp .single-stamp.stamp-two.custom-header .stamp-header {
      height: 65px;
    }
    .oil-stamp .single-stamp.stamp-two .stamp-logo {
      width: 50px;
      height: 50px;
    }
    .oil-stamp .single-stamp.stamp-two .stamp-brand {
      flex: 1 0 calc(100% - 55px);
    }
    .oil-stamp .single-stamp.stamp-two .stamp-footer {
      // padding: 10px 0;
    }
    .oil-stamp .single-stamp.stamp-two .stamp-footer .stamp-detail h4 {
      // padding: 2px 8px;
      font-size: 12px;
    }
    .oil-stamp .single-stamp.stamp-three {
      width: calc(240px - 2px);
      margin: 1px;
      height: calc(144px - 2px);
    }
    .oil-stamp .single-stamp.stamp-three.custom-header .stamp-header {
      height: 65px;
    }
    .oil-stamp .single-stamp.stamp-three .stamp-logo {
      width: 55px;
      height: 55px;
    }
    .oil-stamp .single-stamp.stamp-three .stamp-brand {
      flex: 1 0 calc(100% - 55px);
    }
    .oil-stamp .single-stamp.stamp-three .stamp-footer {
      // padding: 10px 0;
    }
    .oil-stamp .single-stamp.stamp-three .stamp-footer .stamp-detail h4 {
      font-size: 15px;
      transform: scale(1);
      // padding: 0 8px;
    }
    .oil-stamp .single-stamp.stamp-three .stamp-footer .stamp-detail h4 i {
      display: block;
    }
    .oil-stamp .single-stamp.stamp-four {
      width: calc(240px - 2px);
      margin: 1px;
      height: calc(168px - 2px);
    }
    .oil-stamp .single-stamp.stamp-four h4 {
      font-size: 14px;
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-four p {
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-four.custom-header .stamp-header {
      height: 85px;
    }
    .oil-stamp .single-stamp.stamp-four .stamp-logo {
      width: 70px;
      height: 70px;
    }
      .oil-stamp .single-stamp.stamp-four .stamp-brand {
      flex: 1 0 calc(100% - 75px);
    }
    .oil-stamp .single-stamp.stamp-four .stamp-footer {
      // padding: 10px 0;
    }
    .oil-stamp .single-stamp.stamp-four .stamp-footer .stamp-detail h4 {
      font-size: 16px;
      transform: scale(1);
      // padding: 0 8px;
    }
    .oil-stamp .single-stamp.stamp-four .stamp-footer .stamp-detail h4 i {
      display: block;
    }
    .oil-stamp .single-stamp.stamp-five {
      width: calc(96px - 2px);
      margin: 1px;
      height: calc(192px - 2px);
    }
    .oil-stamp .single-stamp.stamp-five h4,
    .oil-stamp .single-stamp.stamp-five p {
      font-size: 11px;
      transform: initial;
    }
    .oil-stamp .single-stamp.stamp-five .stamp-header {
      flex-direction: column;
      text-align: center;
      padding-right: 0;
    }
    .oil-stamp .single-stamp.stamp-five .stamp-header .stamp-logo {
      width: 40px;
      height: 40px;
    }
    .oil-stamp .single-stamp.stamp-five .stamp-body {
      padding: 2px;
    }
    .oil-stamp .single-stamp.stamp-five .stamp-body p {
      white-space: nowrap;
      font-size: 10px;
      transform: initial;
    }
    .oil-stamp .single-stamp.stamp-five.custom-header .stamp-header {
      height: 90px;
    }
    .oil-stamp .single-stamp.stamp-five .stamp-footer {
      // padding: 0;
    }
    .oil-stamp .single-stamp.stamp-five .stamp-footer .stamp-detail {
      flex: 0 0 100%;
      max-width: 100%;
      padding-bottom: 5px;
      border: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .oil-stamp .single-stamp.stamp-five .stamp-footer .stamp-detail h4 {
      // padding: 0 3px;
      font-size: 14px;
    }
    .oil-stamp .single-stamp.stamp-five .stamp-footer .stamp-detail h4 i {
      display: block;
    }
    .oil-stamp .single-stamp.stamp-six {
      width: calc(192px - 2px);
      margin: 1px;
      height: calc(192px - 2px);
    }
    .oil-stamp .single-stamp.stamp-six h4 {
      font-size: 14px;
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-six p {
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-six.custom-header .stamp-header {
      height: 80px;
    }
    .oil-stamp .single-stamp.stamp-six .stamp-logo {
      width: 70px;
      height: 70px;
    }
    .oil-stamp .single-stamp.stamp-six .stamp-footer {
      // padding: 10px 0;
    }
    .oil-stamp .single-stamp.stamp-six .stamp-footer .stamp-detail {
      max-width: 100%;
      flex: 0 0 100%;
      padding-bottom: 5px;
      border: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .oil-stamp .single-stamp.stamp-six .stamp-footer .stamp-detail h4 {
      font-size: 15px;
      transform: scale(1);
      // padding: 3px 8px;
    }
    .oil-stamp .single-stamp.stamp-six .stamp-footer .stamp-detail h4 i {
      display: block;
    }
    .oil-stamp .single-stamp.stamp-six .stamp-brand {
      flex: 0 1 calc(100% - 70px);
    }
    .oil-stamp .single-stamp.stamp-seven {
      width: calc(264px - 2px);
      margin: 1px;
      height: calc(192px - 2px);
    }
    .oil-stamp .single-stamp.stamp-seven h4 {
      font-size: 14px;
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-seven p {
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-seven .stamp-logo {
      width: 65px;
      height: 65px;
    }
    .oil-stamp .single-stamp.stamp-seven .stamp-brand {
          flex: 1 0 calc(100% - 65px);
    }
    .oil-stamp .single-stamp.stamp-seven.custom-header .stamp-header {
      height: 82px;
    }
    .oil-stamp .single-stamp.stamp-seven .stamp-footer {
      // padding: 10px 0;
    }
    .oil-stamp .single-stamp.stamp-seven .stamp-footer .stamp-detail h4 {
      font-size: 16px;
      transform: scale(1);
      // padding: 3px 8px;
    }
    .oil-stamp .single-stamp.stamp-seven .stamp-footer .stamp-detail h4 i {
      display: block;
    }
    .oil-stamp .single-stamp.stamp-seven .stamp-footer .stamp-detail h4 .far {
      padding-right: 53px;
    }
    // .oil-stamp .single-stamp.stamp-seven .stamp-footer .stamp-detail:nth-child(2) {
    //   text-align: right;
    // }
    .oil-stamp .single-stamp.stamp-seven .stamp-footer .stamp-car-detail {
      // padding: 0 8px;
      display: block;
    }
    .oil-stamp .single-stamp.stamp-eight {
      width: calc(288px - 2px);
      margin: 1px;
      height: calc(192px - 2px);
    }
    .oil-stamp .single-stamp.stamp-eight h4 {
      font-size: 14px;
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-eight p {
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-eight .stamp-logo {
      width: 70px;
      height: 65px;
    }
    .oil-stamp .single-stamp.stamp-eight .stamp-brand {
          flex: 1 0 calc(100% - 75px);
    }
    .oil-stamp .single-stamp.stamp-eight.custom-header .stamp-header {
      height: 82px;
    }
    .oil-stamp .single-stamp.stamp-eight .stamp-footer {
      // padding: 10px 0;
    }
    .oil-stamp .single-stamp.stamp-eight .stamp-footer .stamp-detail h4 {
      font-size: 16px;
      transform: scale(1);
      // padding: 3px 8px;
    }
    .oil-stamp .single-stamp.stamp-eight .stamp-footer .stamp-detail h4 i {
      display: block;
    }
    .oil-stamp .single-stamp.stamp-eight .stamp-footer .stamp-detail h4 .far {
      padding-right: 53px;
    }
    // .oil-stamp .single-stamp.stamp-eight .stamp-footer .stamp-detail:nth-child(2) {
    //   text-align: right;
    // }
    .oil-stamp .single-stamp.stamp-eight .stamp-footer .stamp-car-detail {
      // padding: 0 8px;
      display: block;
    }
    .oil-stamp .single-stamp.stamp-nine {
      width: calc(384px - 2px);
      margin: 1px;
      height: calc(192px - 2px);
    }
    .oil-stamp .single-stamp.stamp-nine h4 {
      font-size: 14px;
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-nine p {
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-nine .stamp-header {
      padding-left: 15px;
    }
    .oil-stamp .single-stamp.stamp-nine.custom-header .stamp-header {
      height: 75px;
    }
    .oil-stamp .single-stamp.stamp-nine .stamp-logo {
      width: 70px;
      height: 50px;
    }
    .oil-stamp .single-stamp.stamp-nine .stamp-footer {
      // padding: 10px 7px;
    }
    .oil-stamp .single-stamp.stamp-nine .stamp-footer .stamp-detail h4 {
      font-size: 18px;
      transform: scale(1);
      // padding: 3px 8px;
      text-align: left;
      margin-bottom: 5px;
    }
    .oil-stamp .single-stamp.stamp-nine .stamp-footer .stamp-detail h4 i {
      display: block;
    }
    .oil-stamp .single-stamp.stamp-nine .stamp-footer .stamp-detail h4 .far {
    }
    // .oil-stamp .single-stamp.stamp-nine .stamp-footer .stamp-detail:nth-child(2) {
    //   text-align: right;
    // }
    .oil-stamp .single-stamp.stamp-nine .stamp-footer .stamp-car-detail {
      // padding: 0 8px;
      display: block;
    }
    .oil-stamp .single-stamp.stamp-ten {
      width: calc(144px - 2px);
      margin: 1px;
      height: calc(216px - 2px);
    }
    .oil-stamp .single-stamp.stamp-ten h4 {
      font-size: 14px;
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-ten .stamp-header {
      flex-direction: column;
      text-align: center;
      padding-right: 0;
    }
    .oil-stamp .single-stamp.stamp-ten .stamp-header .stamp-logo {
      width: 50px;
      height: 50px;
    }
    .oil-stamp .single-stamp.stamp-ten.custom-header .stamp-header {
      height: 100px;
    }
    // .oil-stamp .single-stamp.stamp-ten .stamp-footer {
    //   padding: 0;
    // }
    .oil-stamp .single-stamp.stamp-ten .stamp-footer .stamp-detail {
      max-width: 100%;
      flex: 0 0 100%;
      padding-bottom: 5px;
      border: 0;
      padding-left: 0;
      padding-right: 0;
    }
    .oil-stamp .single-stamp.stamp-ten .stamp-footer .stamp-detail h4 {
      // padding: 0 3px;
      font-size: 14px;
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-ten .stamp-footer .stamp-detail h4 i {
      display: block;
    }
    .oil-stamp .single-stamp.stamp-eleven {
      width: calc(384px - 2px);
      margin: 1px;
      height: calc(384px - 2px);
    }
    .oil-stamp .single-stamp.stamp-eleven h4 {
      font-size: 20px;
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-eleven p {
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-eleven .stamp-header {
      padding-left: 15px;
      padding-right: 20px;
      flex-wrap: nowrap;
    }
    .oil-stamp .single-stamp.stamp-eleven .stamp-body p {
      transform: scale(1);
    }
    .oil-stamp .single-stamp.stamp-eleven.custom-header .stamp-header {
      height: 180px;
    }
    .oil-stamp .single-stamp.stamp-eleven .stamp-logo {
      width: 140px;
      height: 140px;
    }
    .oil-stamp .single-stamp.stamp-eleven .stamp-footer {
      // padding: 10px 7px;
    }
    .oil-stamp .single-stamp.stamp-eleven .stamp-footer .stamp-detail {
      flex: 0 0 100%;
      max-width: 100%;
    }
    .oil-stamp .single-stamp.stamp-eleven .stamp-footer .stamp-detail h4 {
      font-size: 30px;
      transform: scale(1);
      // padding: 3px 8px;
    }
    .oil-stamp .single-stamp.stamp-eleven .stamp-footer .stamp-detail + .stamp-detail {
      padding-top: 35px;
      position: relative;
      border: 0;
      max-width: 100%;
      flex: 0 0 100%;
      padding-bottom: 5px;
      border: 0;
      padding-left: 0;
      padding-right: 0;
    }
    // .oil-stamp .single-stamp.stamp-eleven .stamp-footer .stamp-detail + .stamp-detail:after {
    //   content: 'or';
    //   position: absolute;
    //   left: 8px;
    //   top: 4px;
    //   font-size: 20px;
    // }
    .oil-stamp .single-stamp.stamp-eleven .stamp-footer .stamp-detail .after-content {
              position: absolute;
              left: 8px;
              top: 4px;
              font-size: 20px;
              display: block;
            }

            .after-content {
              display: none;
            }
    .oil-stamp .single-stamp.stamp-eleven .stamp-footer .stamp-car-detail {
      // padding: 10px 8px 0;
      display: block;
    }
    .oil-stamp .single-stamp.stamp-eleven .stamp-footer .stamp-car-detail p {
      font-size: 18px;
    }


    // Tire sticker styling starts
    .sticker-vertical {
      margin: 0 auto;
      display: flex;
      height: 100vh;
      align-items: center;
    }
    .sticker-wrapper {
      width: calc(384px - 2px);
      margin: 1px;
      height: calc(480px - 2px);
      margin: 1px;
      border: 1px solid black;
      border-radius: 5px;
      background-color: white;
      padding: 10px 15px;
      color: black;
      margin: 0;
      overflow: hidden;
      page-break-after:auto;
    }
    .sticker-wrapper .sticker-label {
      font-size: 14px;
      font-weight: 600;
    }
    .text-limit {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .sticker-wrapper .sticker-label.small {
      font-size: 14px;
      font-weight: normal;
    }
    .sticker-wrapper .sticker-bold-label {
      font-size: 20px;
      font-weight: bold;
    }
    .sticker-wrapper .sticker-big-label {
      font-size: 20px;
      font-weight: bold;
    }
    .sticker-wrapper .sticker-label.small strong {
      display: block;
      font-size: 20px;
      font-weight: bold;
    }
    .sticker-wrapper .with-border {
      border-bottom: 1.2px solid black;
      margin-bottom: 15px;
    }
    .sticker-wrapper .sticker-date, .sticker-wrapper .sticker-current-odometer {
      min-width: 170px;
    }
    .sticker-customer-name {
      font-size: 26px;
      font-weight: bold;
      line-height: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .sticker-tire-wrapper {
      margin-top: 10px;
      border-top: 1px solid black;
      padding-top: 10px;
    }
    .line-height {
      line-height: 1;
    }
    .row {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
      margin-left: -15px;
    }

    .col, .col-6 {
      position: relative;
      width: 100%;
      padding-right: 15px;
      padding-left: 15px;
    }

    .col-6 {
      flex: 0 0 50%;
      max-width: 50%;
    }

    .col {
      flex-basis: 0;
      flex-grow: 1;
      max-width: 100%;
    }

    .font-bold {
      font-weight: bold !important;
    }

    .font-24 {
      font-size: 24px;
    }

    .font-16 {
      font-size: 16px;
    }

    .mt-2, .my-2 {
      margin-top: 0.5rem !important;
    }

    .mt-3, .my-3 {
      margin-top: 1rem !important;
    }

    .mt-4, .my-4 {
      margin-top: 1.5rem !important;
    }

    *, *::before, *::after {
      box-sizing: border-box;
    }
    // Tire sticker styling Ends

    @page {
      margin: 0cm;
    }
    @page:first {
  }
  @page:last {
      margin: 0cm;
  }
  @page:left {
      margin: 0cm;
  }
  @page:right {
      margin: 0cm;
  }
      `
